// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EL97","name":"styles_name__3aPCf","phone":"styles_phone__3u4FT"};